import { IDX_DB_VALUE_KEYS, indexedDbStorage } from "@/utils/indexDBStorage";
import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

interface ICGPStore {
  activityCGP?: {
    id: string;
    CGPercent: number;
    lastFetch: Date;
  }[];
}

const useCGPStore = create<ICGPStore>()(
  persist((set) => ({}), {
    name: IDX_DB_VALUE_KEYS.cgPercent,
    storage: indexedDbStorage as unknown as PersistStorage<unknown>,
    partialize: (state) => ({
      activityCGP: state?.activityCGP,
    }),
  })
);

export default useCGPStore;
